export class AnnotationEvent {
  dashboardId: number;
  panelId: number;
  userId: number;
  time: any;
  timeEnd: any;
  isRegion: boolean;
  text: string;
  type: string;
  tags: string;
}
